module.exports = __webpack_public_path__ + "img/relogio.6e3a88be.svg";